export default () => __CLIENT__ && !!window.__INITIAL_STATE__



// WEBPACK FOOTER //
// ./src/utils/initialLoad.js